import React from 'react'
import { IProduct } from '@core/api/Products/types'
import { useRelatedProducts } from '@core/components/ProductDetail/useRelatedProducts'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import ProductRelationBase from '@core/components/ProductDetail/ProductRelations/ProductRelationBase'
import ProductCarousel from '@core/components/ProductCollection/ProductCarousel'
import { LYSTypography } from '@core/components/Primitives'
import styles from './index.module.less'
export const useSparePartsProducts = (product?: IProduct) => {
  const { relatedProducts, isLoading } = useRelatedProducts(
    product,
    'sparePart'
  )
  return { relatedProducts, isLoading }
}

const SparePartsProductRelations: React.FC = () => {
  const { t } = useTranslation()
  const { product } = useProductDetailContext() || {}
  const { relatedProducts, isLoading } = useSparePartsProducts(product)

  return (
    <>
      <ProductRelationBase
        title={t`productDetail.sparePart.title`}
        products={relatedProducts}
        slots={{
          title: () => (
            <LYSTypography.Title
              level={2}
              data-testid="recommendation-product-carousel"
              visualAppearance={'h3'}
              className={styles.titleCenter}
            >
              {t`productDetail.sparePart.title`}
            </LYSTypography.Title>
          ),

          products: () => (
            <ProductCarousel
              productItems={relatedProducts}
              loading={isLoading}
              minimizedCard={true}
            />
          ),
        }}
      />
    </>
  )
}

export default SparePartsProductRelations
